<div class="wrap">
  <h2>{{data.title}}</h2>
  <form [formGroup]="addPaymentDefundForm" id="addPaymentDefundForm" (ngSubmit)="onSubmit()">
    <div class="group_input">
      <mat-form-field appearance="outline">
        <mat-label>Montant</mat-label>
        <input matInput type="number" formControlName="amount">
      </mat-form-field>
  
      <mat-form-field appearance="outline">
        <mat-label>Type</mat-label>
        <mat-select formControlName="type" >
          <mat-option *ngFor="let t of paymentTypeList" [value]="t">
            {{t.value}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>

  <div class="btn_action">
    <button class="back" type="button" (click)="dialogRef.close()">Annuler</button>
    <button class="confirm" type="submit" form="addPaymentDefundForm" appChangeColorTheme attribute="bgc">Confirmer</button>
  </div>
</div>
